export default "__VITE_ASSET__BTVVa_Ti__"